import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="82jjlxpPR4U"
                    title="INSTAR IN-5905HD Objektivjustage"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="INSTAR IN-5905HD Objektivjustage"
              footer={
                <EuiText>
                  <p>Wir zeigen Ihnen in diesem Video wie Sie bei einer INSTAR IN-5905HD Überwachungskamera das Objektiv scharfstellen können. Jenachdem welchen Bereich man überwachen möchte, ist es ggf. nötig das Objektiv auf den gewünschten Bereich einzustellen.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}






// import React from 'react'

// import { Player } from 'video-react'

// import {
//     EuiText,
//     EuiTitle,
//     EuiIcon,
//     EuiPanel
//   } from '@elastic/eui'

// import { OutboundLink } from 'gatsby-plugin-gtag'

// require('../../../Layout/chrome/assets/video.css')

// function VideoCard() {
//   return (
//     <EuiPanel paddingSize="m">
//         <EuiTitle size="s"><h4>Lense Adjustment</h4></EuiTitle>
//         <Player>
//         <source src="/videos/Objektiv_scharfstellen_bei_einer_INSTAR_IN_5905HD.mp4" />
//         </Player>
//         <EuiText>
//             <p>Wir zeigen Ihnen in diesem Video wie Sie bei einer INSTAR IN-5905HD Überwachungskamera das Objektiv scharfstellen können. Jenachdem welchen Bereich man überwachen möchte, ist es ggf. nötig das Objektiv auf den gewünschten Bereich einzustellen. Auf <OutboundLink href="https://www.youtube.com/watch?v=82jjlxpPR4U" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
//         </EuiText>
//     </EuiPanel>
//   );
// }

// export default VideoCard